export enum NotificationPermissionState {
  DEFAULT = "default",
  GRANTED = "granted",
  DENIED = "denied",
}
